document.addEventListener('DOMContentLoaded', () => {
        const targetSectionStory = document.getElementById('story');
        const targetSectionProduct = document.getElementById('product-info');
        const link1 = document.getElementById('story-link');
        const link2 = document.getElementById('product-link');


        if (!targetSectionStory || !targetSectionProduct) {
            console.error('Target section or element to toggle not found.');
            return;
        }

        const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.target === targetSectionStory) {
                if (entry.isIntersecting) {
                    link1.classList.add('active');
                    link2.classList.remove('active');
                } 
            } else if (entry.target === targetSectionProduct) {
                if (entry.isIntersecting) {
                    link2.classList.add('active');
                    link1.classList.remove('active');
                } 
            }
        });
    };

    const options = {
    root: null, 
    rootMargin: '0px',
    threshold: 0.25
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (targetSectionStory) {
        observer.observe(targetSectionStory);
    }
    if (targetSectionProduct) {
        observer.observe(targetSectionProduct);
    }

    });